import moment from 'moment';

const datemask = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        priority: 1000,
        link: function (scope, iElement, iAttrs, ngModelCtrl) {
            var format = 'DD.MM.YYYY';
            var isoFormat = 'YYYY-MM-DD';


            function parseViewValue(value) {
                var d = moment(value, 'DDMMYYYY', true);
                if (d.isValid()) {
                    return d.format(isoFormat);
                }

                return value;
            }

            function formatViewValue(value) {
                var d = moment(value, 'YYYY-MM-DD', true);
                if (d.isValid()) {
                    return d.format(format);
                }
            }

            function validateValue(modelValue, viewValue) {
                var value = modelValue;
                if (value === null || angular.isUndefined(value) || value === "") {
                    return true;
                }

                var d = moment(value, isoFormat, true);
                return d.isValid();
            }

            ngModelCtrl.$parsers.push(parseViewValue);
            ngModelCtrl.$formatters.push(formatViewValue);
            ngModelCtrl.$validators.datemask = validateValue;

        }
    };
};

export {datemask};



// WEBPACK FOOTER //
// ./app/components/common/forms/datemask.js